export default {
    props: ['store', 'index', 'displayLanguage'],
    data() {
        return {};
    },
    computed: {
        _languages() {
            return this.store.state.languages;
        },
        blocks() {
            return this.store.state.blocks;
        },
        me() {
            return this.store.state.blocks[this.index];
        },
        blockHandle() {
            const h = this.me.contents[this.displayLanguage];
            return h || {};
        },
        blockData() {
            const d = this.blockHandle.data;
            return d || {};
        },
        postID() {
            return this.store.state.post_id;
        },
        settings() {
            return this.store.state.settings || []
        },
        settingsData() {
            return this.settings.data[this.displayLanguage] || []
        },
        is_preview() {
            return this.store.state.isPreview;
        }
    },
    mounted() {
        /**
         * Initial block data
         */
        this._languages.map((l) => {
            try {
                const data = this.me.contents[l].data;

                this.me.contents[l].data = data || {};
            } catch (e) {
                const tmp = JSON.parse(JSON.stringify(this.me));

                tmp.contents[l] = {};
                tmp.contents[l].data = {};

                this.store.updateBlocks(this.index, tmp);
            }
            return true;
        });
    },
    methods: {
        deepget: function(obj, path, defaultValue) {
            const props = path.split ? path.split('.') : path;
            let lastReference = obj;

            for (var i = 0, len = props.length; i < len; i++) {
                if (lastReference !== null && lastReference[props[i]] !== undefined) {
                    lastReference = lastReference[props[i]];
                } else {
                    return defaultValue || undefined;
                }
            }

            return lastReference;
        },
        has: function(prop, def) {
            return this.deepget(this.blockData, prop, def);
        },
        has_setting: function(prop, def) {
            return this.deepget(this.settings, prop, def);
        },
        setting: function(prop, def) {
            return this.deepget(this.settingsData, prop, def);
        },
        post_id: function() {
            return this.postID;
        },
        has_block: function(prop, def) {
            return this.deepget(this.me, prop, def);
        },
        _updateMe: function(prop, value) {
            return this.$vueSet(this.me, prop, value);
        },
        _updateValue: function(prop, value) {
            return this.$vueSet(this.blockData, prop, value);
        },
        sortUpdate: function() {
            // let blocks = this.blocks.sort(this.store.compare);
            this.store.init('blocks', this.blocks);
        },
        fixScroll: function() {
            const $offset = !this.index ? 0 : 60
            $('html, body').animate({
                scrollTop: $('#' + this.me.index).offset().top - $offset
            }, 500);
        },
        rgbaToString: function(prop, fallback = null, alpha = 1) {
            if (!prop) return;

            var color = typeof prop === 'object' && typeof prop.r !== 'undefined' ? prop : this.has(prop);

            if (typeof color !== 'object') {
                if (typeof fallback === 'string') {
                    return fallback;
                } else if (typeof fallback === 'object' && typeof fallback.rgba === 'object') {
                    color = fallback.rgba;
                }
            }

            if (color.a < alpha) {
                alpha = color.a;
            }

            var rgba = 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + alpha + ')';

            return rgba;
        },
        chunkify: function(a, n, balanced) {
            if (n < 2)
                return [a];

            var len = a.length,
                out = [],
                i = 0,
                size;

            if (len % n === 0) {
                size = Math.floor(len / n);
                while (i < len) {
                    out.push(a.slice(i, i += size));
                }
            } else if (balanced) {
                while (i < len) {
                    size = Math.ceil((len - i) / n--);
                    out.push(a.slice(i, i += size));
                }
            } else {
                n--;
                size = Math.floor(len / n);
                if (len % size === 0)
                    size--;
                while (i < size * n) {
                    out.push(a.slice(i, i += size));
                }
                out.push(a.slice(size * n));
            }

            return out;
        }
    },
};
